import {StyledGrid} from 'presentation/components';
import React from 'react';
import {PrescriptionsCard} from '../PrescriptionsCard';
import {PrescriptionsCardGridType} from './types';

export const PrescriptionsCardGrid = ({list}: PrescriptionsCardGridType) => (
	<StyledGrid.Root spacing={2}>
		{list?.map((card, index) => (
			<StyledGrid.Item key={index} xs={12} sm={12} md={6} lg={4} xl={4}>
				<PrescriptionsCard
					prescription={card}
					dataTestId={`prescription-card-${index + 1}`}
				/>
			</StyledGrid.Item>
		))}
	</StyledGrid.Root>
);
